import React from 'react';
import '../styles/theme.css';
import '../styles/Login.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LoginVerificationBand from '../components/LoginVerificationBand';
/* IMPORTS */

function LoginPage() {
  return (
    <div className="lo-root">
      <div id="loginnavbarslot" className="lo-slot-loginnavbarslot">
        <Navbar activePage={"Login"} />
      </div>
      <div id="loginverificationband" className="lo-slot-loginverificationband">
        <LoginVerificationBand />
      </div>
      <div id="loginfooterslot" className="lo-slot-loginfooterslot">
        <Footer />
      </div>
    </div>
  );
}

export default LoginPage;